import React from "react";
import { useState } from "react";
import Details from "../../../Components/BRSR/SectionA/Details";
import ProductAndServices from "../../../Components/BRSR/SectionA/ProductAndServices";
import Operations from "../../../Components/BRSR/SectionA/Operations";
import Employees from "../../../Components/BRSR/SectionA/Employees";
import HoldingCompanies from "../../../Components/BRSR/SectionA/HoldingCompanies";
import Transparency from "../../../Components/BRSR/SectionA/Transparency";
import styles from "../../../styles/brsr/general.module.css";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import LensIcon from "@mui/icons-material/Lens";
import ReviewPage from "../../../Components/Common/ReviewPage";

const SectionA = () => {
  const [currentComponent, setCurrentComponent] = useState("Details");

  const steps = [
    "Details",
    "Products",
    "Operations",
    "Employees",
    "Holdings",
    "Transparency",
  ];

  const DottedLineBetweenSteps = () => {
    return (
      <div
        style={{
          width: "100%",
          height: "3px",
          background:
            "repeating-linear-gradient(to right, #B3B3B3, #B3B3B3 10px, transparent 5px, transparent 15px)",
        }}
      />
    );
  };

  const goToNextComponent = () => {
    const currentIndex = steps.findIndex((step) => step === currentComponent);
    if (currentIndex < steps.length - 1) {
      setCurrentComponent(steps[currentIndex + 1]);
    }
  };

  return (
    <>
      <div className={styles.section_navbar}>
        <div className={styles.section_navbar_wrapper}>
          <div onClick={() => setCurrentComponent("Details")}>
            {currentComponent === "Details" ? (
              <RadioButtonUncheckedIcon sx={{ color: "#EB7E0E" }} />
            ) : (
              <LensIcon sx={{ color: "#A8A8A8" }} />
            )}
          </div>
          {DottedLineBetweenSteps()}
          <div onClick={() => setCurrentComponent("Products")}>
            {currentComponent === "Products" ? (
              <RadioButtonUncheckedIcon sx={{ color: "#EB7E0E" }} />
            ) : (
              <LensIcon sx={{ color: "#A8A8A8" }} />
            )}
          </div>

          {DottedLineBetweenSteps()}
          <div onClick={() => setCurrentComponent("Operations")}>
            {currentComponent === "Operations" ? (
              <RadioButtonUncheckedIcon sx={{ color: "#EB7E0E" }} />
            ) : (
              <LensIcon sx={{ color: "#A8A8A8" }} />
            )}
          </div>
          {DottedLineBetweenSteps()}
          <div onClick={() => setCurrentComponent("Employees")}>
            {currentComponent === "Employees" ? (
              <RadioButtonUncheckedIcon sx={{ color: "#EB7E0E" }} />
            ) : (
              <LensIcon sx={{ color: "#A8A8A8" }} />
            )}
          </div>
          {DottedLineBetweenSteps()}
          <div onClick={() => setCurrentComponent("Holdings")}>
            {currentComponent === "Holdings" ? (
              <RadioButtonUncheckedIcon sx={{ color: "#EB7E0E" }} />
            ) : (
              <LensIcon sx={{ color: "#A8A8A8" }} />
            )}
          </div>
          {DottedLineBetweenSteps()}
          <div onClick={() => setCurrentComponent("Transparency")}>
            {currentComponent === "Transparency" ? (
              <RadioButtonUncheckedIcon sx={{ color: "#EB7E0E" }} />
            ) : (
              <LensIcon sx={{ color: "#A8A8A8" }} />
            )}
          </div>
        </div>

        <div className={styles.section_navbar_steps}>
          <p>Details</p>
          <p>
            Products / <br />
            Services
          </p>
          <p>Operations</p>
          <p>Employees</p>
          <p>Holding, Subsidiary & Associates & CSR Details</p>
          <p>Transparency & Disclosures Compliances</p>
        </div>
      </div>
      <p className={styles.section_heading}>SECTION A: GENERAL DISCLOSURE.</p>
      <div>
        {currentComponent === "Details" ? (
          <Details onSave={goToNextComponent} />
        ) : currentComponent === "Products" ? (
          <ProductAndServices onSave={goToNextComponent} />
        ) : currentComponent === "Operations" ? (
          <Operations onSave={goToNextComponent} />
        ) : currentComponent === "Employees" ? (
          <Employees onSave={goToNextComponent} />
        ) : currentComponent === "Holdings" ? (
          <HoldingCompanies onSave={goToNextComponent} />
        ) : currentComponent === "Transparency" ? (
          <Transparency onSave={goToNextComponent} />
        ) : null}
      </div>
    </>
  );
};

export default SectionA;
